<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import OrderStatisticsPanel from "@/components/order-statistics-panel.vue";

export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader, OrderStatisticsPanel },
    data() {
        return {
            title: "",
            items: [],
            loading: false,
            userinfo: [],
            activetab: "daily",
            monthdate: [],
            dailydate: [],
            pickerOptions: {
                shortcuts: [{
                    text: this.$t('statistics.sales.month.recent3'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 2);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('statistics.sales.month.recent6'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 5);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('statistics.sales.month.recent12'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 11);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            pickerOptionsdaily: {
                shortcuts: [{
                    text: this.$t('statistics.sales.daily.recent3'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: this.$t('statistics.sales.daily.recent7'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit("pick", [start, end]);
                    }
                }, {
                    text: this.$t('statistics.sales.daily.recent30'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() -1);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            statsData: null
        };
    },
    computed: {
        showTrend() {
            return this.activetab !== "all";
        },
    },
    mounted() {
        this.title = this.$t("menuitems.setting.statistics");
        this.items = [
            {
                text: this.$t("dashboard.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.setting.statistics"),
                active: true,
            },
        ];
        this.userinfo = JSON.parse(localStorage.getItem("user"));
        this.initDefaultDailyRange();
        this.onSubmit();
    },
    methods: {
        initDefaultDailyRange() {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 6);
            const fmt = (d) => {
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                return `${y}-${m}-${day}`;
            };
            this.dailydate = [fmt(start), fmt(end)];
        },
        switchdatatype() {
            this.statsData = null;
            if (this.activetab == 'all' || this.activetab == 'daily') {
                this.onSubmit();
            }
        },
        onSubmit() {
            var that = this
            that.statsData = null
            that.loading = true
            let postdata = {}
            if (that.activetab == 'daily') {
                postdata = {
                    action: "querystatistics",
                    date: that.dailydate,
                    type: that.activetab,
                }
            } else if (that.activetab == 'month') {
                postdata = {
                    action: "querystatistics",
                    date: that.monthdate,
                    type: that.activetab,
                }
            } else {
                postdata = {
                    action: "querystatistics",
                    type: that.activetab,
                }
            }
            that.$axios
                .post(
                    that.apiuri,
                    postdata,
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    if (response.data.status == 200) {
                        that.statsData = response.data.data;
                    } else {
                        that.$message.error(response.data.msg);
                    }
                })
                .catch(function () {
                    that.loading = false;
                });
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-loading="loading">
                        <el-tabs v-model="activetab" @tab-click="switchdatatype">
                            <el-tab-pane :label="$t('statistics.sales.daily.text')" name="daily">
                                <el-form ref="form" label-width="80px">
                                    <el-form-item :label="$t('statistics.sales.daily.v2')">
                                        <el-date-picker v-model="dailydate" type="daterange" align="right" unlink-panels
                                            :range-separator="$t('statistics.sales.month.to')"
                                            :start-placeholder="$t('statistics.sales.daily.start')"
                                            :end-placeholder="$t('statistics.sales.daily.end')"
                                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                            :picker-options="pickerOptionsdaily">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">{{ $t("statistics.sales.search")
                                            }}</el-button>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('statistics.sales.month.text')" name="month">
                                <el-form ref="form" label-width="80px">
                                    <el-form-item :label="$t('statistics.sales.month.v2')">
                                        <el-date-picker v-model="monthdate" type="monthrange" align="right"
                                            unlink-panels :range-separator="$t('statistics.sales.month.to')"
                                            :start-placeholder="$t('statistics.sales.month.start')"
                                            :end-placeholder="$t('statistics.sales.month.end')" value-format="yyyy-MM"
                                            :picker-options="pickerOptions">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">{{ $t("statistics.sales.search")
                                            }}</el-button>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('statistics.sales.all')" name="all">
                                <el-form ref="form" label-width="80px">
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit">{{ $t("statistics.sales.search")
                                            }}</el-button>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                        <OrderStatisticsPanel :stats="statsData" :show-trend="showTrend" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
